export default __webpack_public_path__ + "static/media/detail_big_14_6.f0e38bc0.jpg";